<template>
	<div class="shopTraveler">
		<back-to></back-to>
		<van-address-edit :area-list="areaList" :address-info="AddressInfo" @save="onSave" />
	</div>
</template>

<script>
	import BackTo from '@/components/BackTo.vue'
	import {
		mapGetters
	} from 'vuex'
	import {
		Toast
	} from 'vant';
	import {
		areaList
	} from '@vant/area-data';
	export default {
		name: 'shopTraveler',
		components: {
			BackTo
		},
		data() {
			return {
				name: '',
				addr: '',
				tel: '',
				areaList,
				AddressInfo: {}
			}
		},
		computed: {
			...mapGetters('account', ['userInfo'])
		},
		mounted() {
			if (this.$route.query.type == 1) {
				this.getInfo()
			}
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		},
		methods: {
			getInfo() {
				var jsonData = {
					Id: this.$route.query.id
				}
				this.$get(
					this.$connectHttpSweet + '/ShippingAddress/GetById', jsonData
				).then(res => {
					this.AddressInfo = {
						areaCode: '' + res.result.country,
						name: res.result.realName,
						tel: res.result.userPhone,
						province: res.result.provStr,
						city: res.result.cityStr,
						county: res.result.countryStr,
						addressDetail: res.result.address
					}
				})
			},
			onSave(e) {
				console.log(e)
				if (this.$route.query.type == 1) {
					var jsonData = {
						shippingAddress: {
							id: this.$route.query.id,
							realName: e.name,
							userPhone: e.tel,
							phoneAreaCode: '86',
							// prov:  Number(e.areaCode),
							// city:  Number(e.areaCode),
							country: Number(e.areaCode),
							provStr: e.province,
							cityStr: e.city,
							countryStr: e.county,
							address: e.addressDetail,
							webUserId: this.userInfo.userId,
						}
					}
				} else {
					var jsonData = {
						shippingAddress: {
							realName: e.name,
							userPhone: e.tel,
							phoneAreaCode: '86',
							// prov:  Number(e.areaCode),
							// city:  Number(e.areaCode),
							country: Number(e.areaCode),
							provStr: e.province,
							cityStr: e.city,
							countryStr: e.county,
							address: e.addressDetail,
							webUserId: this.userInfo.userId,
							isDefault: false,
						}
					}
				}

				this.$post(
					this.$connectHttpSweet + '/ShippingAddress/CreateOrUpdate', jsonData
				).then(res => {
					if (res.success) {
						Toast('保存成功')
						this.$router.back()
					} else {
						Toast('保存失败')
					}
				})
			}
		}
	}
</script>

<style>
</style>
